export default class FrequencyFinder {


  constructor() {
    this.audio = null;
    this.interval = null;
    this.action = null;
    this.analyser = null;
    this.dataArray = null;
  }

  async start(interval) {

    this.audio = await navigator.mediaDevices.getUserMedia({
      sampleRate: 10000,
      audio: true,
      video: false
    })

    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();

    this.analyser = audioContext.createAnalyser();
    this.analyser.fftSize = 4096;
    this.dataArray = new Float32Array(this.analyser.frequencyBinCount);


    let source = audioContext.createMediaStreamSource(this.audio);
    source.connect(this.analyser);

    this.interval = setInterval(() => {

      if (!this.action) { return; }

      // Calculate frequency with highest decibel level.
      this.analyser.getFloatTimeDomainData(this.dataArray);
      let frequency = this.autoCorrelate(this.dataArray, audioContext.sampleRate);

      console.log(frequency);
      let note = this.getNote(frequency);
      if (note != null) {
        this.action(note);
      }

    }, interval)
  }

  stop() {
    console.log("Stopping recording");
    console.log(this.listener);
    clearInterval(this.interval);
    this.audio.getTracks().forEach(track => track.stop());
  }

  getNote(frequency) {
    if (frequency > 3000) {
      return "none";
    } else if (frequency < 100) {
      return "none";
    } else if (frequency < 200) {
      return "down";
    } else if (frequency < 400) {
      return "up";
    } else if (frequency < 1400) {
      return "special2";
    } else if (frequency < 1600) {
      return "special";
    } else if (frequency < 1800) {
      return "left";
    } else if (frequency < 2500) {
      return "right";
    } else {
      return "none";
    }
  }

  autoCorrelate(buf, sampleRate) {
    // Implements the ACF2+ algorithm
    let SIZE = buf.length;
    let rms = 0;

    for (let i = 0; i < SIZE; i++) {
      rms += buf[i] * buf[i];
    }
    rms = Math.sqrt(rms / SIZE);
    if (rms < 0.01) // not enough signal
      return -1;

    let r1 = 0, r2 = SIZE - 1, thres = 0.2;
    for (let i = 0; i < SIZE / 2; i++){
      if (Math.abs(buf[i]) < thres) { r1 = i; break; }
    }
    for (var i = 1; i < SIZE / 2; i++){
      if (Math.abs(buf[SIZE - i]) < thres) { r2 = SIZE - i; break; }
    }

    buf = buf.slice(r1, r2);
    SIZE = buf.length;

    var c = new Array(SIZE).fill(0);
    for (let i = 0; i < SIZE; i++){
      for (let j = 0; j < SIZE - i; j++){
        c[i] = c[i] + buf[j] * buf[j + i];
      }
    }

    var d = 0; while (c[d] > c[d + 1]) d++;
    var maxval = -1, maxpos = -1;
    for (let i = d; i < SIZE; i++) {
      if (c[i] > maxval) {
        maxval = c[i];
        maxpos = i;
      }
    }
    var T0 = maxpos;

    var x1 = c[T0 - 1], x2 = c[T0], x3 = c[T0 + 1];
    let a = (x1 + x3 - 2 * x2) / 2;
    let b = (x3 - x1) / 2;
    if (a) T0 = T0 - b / (2 * a);

    return sampleRate / T0;
  }
}